import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./utils/global.scss";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { router } from "router";
import App from "./App";
import store from "store/store";
import { Toaster } from "react-hot-toast";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Toaster
      position="top-right"
      reverseOrder={false}
      toastOptions={{
        style: {
          fontSize: "14px",
        },
      }}
    />
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <GoogleOAuthProvider clientId="147799446483-6v8f9phtlb7gv7n2rgdh9u99ed69hp97.apps.googleusercontent.com" >
          <App />
        </GoogleOAuthProvider>
      </LocalizationProvider>
    </Provider>
  </>

);

reportWebVitals();
